<template>
  <div id="searchGeneralContainer" class="container__btn">
      <v-text-field
      id="placeholder__searchGeneral"
        class="mt-0 pt-0 input__search"
        v-model="inputValue"
        hide-details
        single-line
        prepend-icon="mdi-magnify"
        v-bind:placeholder="placeholder"
        @keyup.enter="search"
        @click:prepend="search"
        ref="searchGlobal"
        :append-icon="inputValue ? 'mdi-close' : ''"
        @click:append="clearTextField"
      >
      </v-text-field>

  </div>
</template>

<script>
import Superplaceholder from 'superplaceholder';

export default {
  name: 'SearchGeneral',
  props: {
    value: String,
    placeholder: String,
    id: String,
    querySearch: String,
  },
  data(props) {
    return {
      className: props.class,
      inputValue: props.inputValue || '',
      openSearchMobile: false,
    };
  },
  created() {
    this.inputValue = this.querySearch;
  },
  mounted() {
    const messages = [
      'Alta en DIRAYA',
      'El ordenador no enciende',
      'Estación clínica va lenta',
      'No puedo entrar en DIRAYA',
      'La impresora no funciona',
    ];

    const placeholderInstance = new Superplaceholder({
      el: document.getElementById('placeholder__searchGeneral'),
      sentences: messages,
      options: {
        loop: true,
        startOnFocus: false,
      },
    });

    placeholderInstance.start();
  },
  methods: {
    search() {
      this.$emit('search', { q: this.inputValue });
    },
    clearTextField() {
      this.inputValue = '';
    },
  },
};
</script>

<style>
  .container__btn {
    width: 60%;
  }
  .input__search:hover .icon__close {
    color: #27846d !important;
  }
  @media (max-width: 600px) {
    .container__btn {
      width: 1000%;
    }
  }
</style>
